export default {
  kpiSummary: null,
  revenueOverTime: null,
  peakHours: null,
  productPerformance: null,
  orderSources: null,
  paymentMethods: null,
  customerStats: null,
  operations: null,
  orderLocations: null,
  revenueByPayment: null,
  weekdayHeatmap: null,
  avgOrderValue: null,
  revenueByArea: null,
  newVsReturning: null,
  popularIngredients: null,
  addressMap: null,
};
